import { ModelProps } from '@adobe/aem-react-editable-components';

const isEmpty = <T extends ModelProps>(props: T) =>
	!props || !props.cqItemsOrder || props.cqItemsOrder.length === 0;

export default isEmpty;
